<template lang="pug">
  r-form( 
    submit-text='guardar'
    title='crear tope de asignacion familiar'
    v-bind='formProps'
    v-model='formData'
    @reset='handleFormReset'
    @submit='handleFormSubmit'
    )
</template>

<script>
//
import { RForm } from '@/components/reusable_components/next'
import HrFamilyAssignmentService from '@/services/api/HumanResource/HrFamilyAssignment'
import catcher from '@/services/translator'
//
export default {
  name: 'view-family-assignament-create',
  components: {
    RForm,
  },
  data: () => ({
    formData: {},
    formProps: {
      fields: HrFamilyAssignmentService.fields(),
    }
  }),
  methods: {
    handleFormReset() {
      this.formData = HrFamilyAssignmentService.toCreate()
    },
    handleFormSubmit() {
      HrFamilyAssignmentService.create(this.formData).then(this.success).catch(this.error)
    },
    success() {
      this.showSuccessSnackbar('Tope de asignacion familiar creado exitosamente.')
      this.$router.push({ name: 'family-assignment-list' })
    },
    error(error) {
      this.showErrorSnackbar(catcher(HrFamilyAssignmentService.model(), error.response.data))
    },
  },
  mounted() {
    this.handleFormReset()
  },
}
</script>

